import React from 'react';
import { Text, TextVariant } from '@naf/text';
import ResponsiveImage from '@components/image/ResponsiveImage';
import { IMAGE_SIZES } from '@components/image/ResponsiveImage.sizes';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import * as S from './BlockImage.styles';

export const BlockImage = ({ image }: { image?: CloudinaryImageType }) => {
  const { publicId, caption, altText } = image || {};

  return (
    (publicId && (
      <S.ImageWrapper className="BlockImage">
        <ResponsiveImage imageId={publicId} altText={altText || caption} sizes={IMAGE_SIZES.bodyBlock} />
        {caption && (
          // hack until text support additional tag elements
          <Text tag={'figcaption' as 'span'} variant={TextVariant.Caption}>
            {caption}
          </Text>
        )}
      </S.ImageWrapper>
    )) ||
    null
  );
};

export default BlockImage;
